import React, { useEffect } from 'react'

function AddTitle({ sendDataToParent, onLoad }) {

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  useEffect(() => {
    onLoad(undefined);
  }, []);

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">
            Title<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="Title"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea 
              className="form-control h-100" 
              rows="5" 
              name="Description"
              onChange={handleChange}
            />
            <p className="mt-1">Maximum 1000 Characters</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddTitle